<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">매출현황(상품)</span>
            <span class="txt">이용권, 일반상품, 락커판매에 관한 결제와 환불에 대한 매출을 확인합니다.</span>
        </div>

        <!-- 매출현황 상품일시 -->
        <div class="sales-info-table">
            <div class="top-content">
                <div class="item-box">
                    <span class="tit">이용권 상품 총 매출</span>
                    <span class="count">
                        <span class="num blue">{{ (ticketTypeSale.total.price || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (ticketTypeSale.total.count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box plus"></div>
                <div class="item-box">
                    <span class="tit">일반 상품 총 매출</span>
                    <span class="count">
                        <span class="num blue">{{ (etcProductPrice || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (etcProductCount || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>

                <div class="item-box minus"></div>
                <div class="item-box">
                    <span class="tit">총 환불</span>
                    <span class="count">
                        <span class="num red">{{ (statRefund.refund.price || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (statRefund.refund.count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>

                <div class="item-box minus"></div>
                <div class="item-box">
                    <span class="tit">미수금</span>
                    <span class="count">
                        <span class="num red">{{ (statRefund.uncol.price || 0) | numberFormatFilter }}원</span>
                        <!--                            <span class='txt'>({{ (statRefund.uncol.count || 0) | numberFormatFilter }}건)</span>-->
                    </span>
                </div>

                <div class="item-box equal"></div>
                <div class="item-box">
                    <span class="tit">합계</span>
                    <span class="count">
                        <span class="num green">
                            {{ ((totalPrice || 0) - statRefund.uncol.price) | numberFormatFilter }}원
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <!-- //매출현황 상품일시 -->

        <div class="sales-table-info">
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">결제수단별 매출</span>
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <span class="tit">결제수단별 매출</span>
                            <p class="txt">
                                이용권 수입+판매상품 수입을 ‘결제수단’ 기준으로 보여줍니다.
                                <br />
                                마일리지를 사용하여 결제한 금액은 실제 수입은 아니므로 합계에 포함되지 않습니다.
                            </p>
                        </div>
                    </div>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>카드</th>
                            <td>{{ (salePayType.card.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.card.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>현금</th>
                            <td>{{ (salePayType.cash.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.cash.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>계좌</th>
                            <td>{{ (salePayType.bank.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.bank.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>기타</th>
                            <td>{{ (salePayType.etc.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.etc.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>핏페이</th>
                            <td>{{ (salePayType.fit.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.fit.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ salePayType.total.count | numberFormatFilter }}건</td>
                            <td class="right">{{ salePayType.total.price | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>마일리지 사용</th>
                            <td>{{ (salePayType.mileage.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (salePayType.mileage.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">이용권구분별 매출</span>
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <span class="tit">이용권구분별 매출</span>
                            <p class="txt">
                                이용권 수입을 ‘이용권 구분’ 기준으로 보여줍니다.
                                <br />
                                패키지는 분리되어 취합됩니다.
                            </p>
                        </div>
                    </div>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>회원권</th>
                            <td>{{ (ticketTypeSale.t.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.t.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>개인</th>
                            <td>{{ (ticketTypeSale.p.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.p.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>OT</th>
                            <td>{{ (ticketTypeSale.o.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.o.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>듀엣</th>
                            <td>{{ (ticketTypeSale.d.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.d.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>그룹</th>
                            <td>{{ (ticketTypeSale.g.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.g.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>쿠폰</th>
                            <td>{{ (ticketTypeSale.c.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.c.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>운동복</th>
                            <td>{{ (ticketTypeSale.s.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.s.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <!-- <tr>
              <th>패키지</th>
              <td>{{ticketTypeSale.pk.count | numberFormatFilter}}건</td>
              <td class="right">{{ticketTypeSale.pk.price | numberFormatFilter}}원</td>
          </tr> -->
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ (ticketTypeSale.total.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (ticketTypeSale.total.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">이용권 등록 현황</span>
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <span class="tit">이용권 등록 현황</span>
                            <p class="txt">
                                이용권 등록현황을 '신규/재등록' 기준으로 보여줍니다. 첫 결제일 기준으로 카운트 됩니다.
                            </p>
                        </div>
                    </div>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>신규</th>
                            <td>{{ (ticketStat.new.count || 0) | numberFormatFilter }}건</td>
                            <!--                            <td class="right">{{ticketStat.new.price | numberFormatFilter}}원</td>-->
                        </tr>
                        <tr>
                            <th>재등록</th>
                            <td>{{ (ticketStat.re.count || 0) | numberFormatFilter }}건</td>
                            <!--                            <td class="right">{{ticketStat.re.price | numberFormatFilter}}원</td>-->
                        </tr>
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ (ticketStat.total.count || 0) | numberFormatFilter }}건</td>
                            <!--                            <td class="right">{{ticketStat.total.price | numberFormatFilter}}원</td>-->
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="item-box etc">
                <table>
                    <colgroup>
                        <col style="width: 220px" />
                        <col style="width: 240px" />
                        <col style="width: 240px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>환불현황</th>
                            <td>{{ (statRefund.refund.count || 0) | numberFormatFilter }}건</td>
                            <td class="right">{{ (statRefund.refund.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>
                                미수금
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">미수금</span>
                                        <p class="txt">조회기간과 상관 없이 누적된 미수금 현황입니다.</p>
                                    </div>
                                </div>
                            </th>
                            <td>
                                <span class="blue" style="text-decoration: underline" @click="uncollectedList">
                                    {{ (uncol.count || 0) | numberFormatFilter }}건
                                </span>
                            </td>
                            <td class="right">{{ (uncol.price || 0) | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>
                                예상 부가세
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">예상 부가세</span>
                                        <p class="txt">
                                            핏투데이케어에 설정 및 등록한 데이터를 통한 대략적인 예상부가세로, 실제
                                            세무자료와 다를 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <td colspan="2">매출 {{ (estiVat.sale || 0) | numberFormatFilter }} 원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                    <br />
                    <span class="txt" style="font-size: 1.5em">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    &nbsp;&nbsp;&nbsp;
                </div>
            </div>
            <div class="line">
                <select-check-form
                    :select-data="['전체', '이용권', '환불', '판매']"
                    :select-value="['all', 'P', 'D', 'C']"
                    :selected-valu="searchBillTypes"
                    title="결제항목"
                    @update:set="(val) => (searchBillTypes = val)"
                />
                <select-check-form
                    :select-data="['전체', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                    :select-value="['all', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                    title="이용권구분"
                    @update:set="onChangeTicketCode"
                />
                <select-check-form
                    :select-data="[...categoryList]"
                    :select-value="[...categoryValList]"
                    :selected-value="searchCategoryNames"
                    title="카테고리명"
                    @update:set="(val) => (searchCategoryNames = val)"
                />
                <select-check-form
                    :select-data="[...prodList]"
                    :select-value="[...prodValList]"
                    :selected-value="searchProductItem"
                    class="w400"
                    title="이용권명"
                    @update:set="(val) => (searchProductItem = val)"
                />
            </div>
            <div class="line">
                <select-form
                    :select-data="['결제수단', '전체', '카드', '현금', '계좌이체', '기타', '핏페이', '마일리지']"
                    :select-value="['', '', 'C', 'L', 'B', 'E', 'T', 'M']"
                    :selected-value="payType"
                    @update:set="(val) => (payType = val)"
                ></select-form>
                <select-form
                    :select-data="['등록구분', '전체', '신규', '재등록']"
                    :select-value="['', '', 'N', 'R']"
                    :selected-value="contractType"
                    @update:set="(val) => (contractType = val)"
                ></select-form>
                <select-check-form
                    :select-data="[...teacherList]"
                    :select-value="[...teacherValueList]"
                    :selected-value="searchTeacher"
                    title="담당강사"
                    @update:set="(val) => (searchTeacher = val)"
                ></select-check-form>
                <select-check-form
                    :select-data="[...staffNameList]"
                    :select-value="[...staffNameValueList]"
                    :selected-value="searchStaff"
                    title="매출직원"
                    @update:set="(val) => (searchStaff = val)"
                ></select-check-form>
                <select-form
                    :disabled="rNm"
                    :select-data="['센터명', '전체', ...chainCenterType]"
                    :select-value="['', '전체', ...chainCenterTypeValue]"
                    :selected-value="selectedCenter"
                    @update:set="(val) => (selectedCenter = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 95px" />
                    <col style="width: 100px" />
                    <col style="width: 125px" />
                    <col style="width: 320px" />
                    <col style="width: 125px" />
                    <col style="width: 160px" />
                    <col style="width: 120px" />
                    <col style="width: 100px" />
                    <col style="width: 100px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button @click="changeTyped('cc_buy_dt', 1)">결제일</button>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button
                                @click="
                                    changeTyped(
                                        ['cc_sale_type_cd', 'cc_prod_type_cd', 'cc_ret_yn', 'cc_exp_type_cd'],
                                        2
                                    )
                                "
                            >
                                결제항목
                            </button>
                        </th>
                        <th>
                            <button @click="changeTyped('cc_ticket_type_cd', 3)">항목명</button>
                        </th>
                        <th>
                            <button @click="changeTyped('cc_total_buy_price', 4)">구매가</button>
                        </th>
                        <th>
                            <button @click="changeTyped('cc_bill_price', 5)">결제금액</button>
                        </th>
                        <th>등록구분</th>
                        <th>
                            <button @click="changeTyped('cc_less_staff_name', 6)">담당강사</button>
                        </th>
                        <th>
                            <button @click="changeTyped('cc_sale_staff_name', 7)">매출직원</button>
                        </th>
                        <th>
                            <button @click="changeTyped('cc_center_nm', 8)">센터명</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="s in saleGoodsList" :key="s.key">
                        <td>{{ s.cc_buy_dt | timestampFilter }}</td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${s.cc_center_id}`,
                                    query: { customerId: s.cc_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ s.cc_customer_nm }}
                            </router-link>
                        </td>
                        <td>
                            {{ convertBillType(s.cc_sale_type_cd, s.cc_prod_type_cd, s.cc_ret_yn, s.cc_exp_type_cd) }}
                        </td>
                        <td class="left">
                            <span
                                :class="{
                                    'type-1': s.cc_ticket_type_cd == 'P',
                                    'type-2': s.cc_ticket_type_cd == 'G',
                                    'type-3': s.cc_ticket_type_cd == 'C',
                                    'type-4': s.cc_ticket_type_cd == 'T',
                                    'type-5': s.cc_ticket_type_cd == 'D',
                                    'type-6': s.cc_ticket_type_cd == 'O',
                                    'type-8': s.cc_ticket_type_cd == 'S',
                                }"
                                class="ico"
                            >
                                {{ convertTicket(s.cc_ticket_type_cd) }}
                            </span>
                            <router-link
                                v-if="
                                    convertBillType(
                                        s.cc_sale_type_cd,
                                        s.cc_prod_type_cd,
                                        s.cc_ret_yn,
                                        s.cc_exp_type_cd
                                    ) === '이용권'
                                "
                                :to="{
                                    path: `/madmin/member/account/${s.cc_center_id}`,
                                    query: {
                                        customerId: s.cc_center_cust_id,
                                        contractId: s.cc_center_contract_id,
                                        allowedCount: null,
                                    },
                                }"
                                class="link"
                            >
                                {{ s.cc_prod_nm }}
                            </router-link>
                            <div v-else style="display: inline">
                                {{ s.cc_prod_nm }}
                            </div>
                            <div v-if="s.cc_memo != null && s.cc_memo !== ''" class="com-tooltip">
                                <span :title="s.cc_memo" class="com-btn blue">메모</span>
                                <div class="detail">
                                    <p class="txt">{{ s.cc_memo }}</p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span v-if="!s.cc_ret_yn && s.cc_bill_seq === '0'">
                                {{ s.cc_total_buy_price | numberFormatFilter }}원
                            </span>
                            <span v-if="!s.cc_ret_yn && s.cc_bill_seq !== '0' && s.cc_prod_type_cd === 'T'">
                                {{ Number(s.cc_bill_seq) + 1 }}차 결제
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span v-if="s.cc_sale_type_cd === '+' && !s.cc_ret_yn">
                                    {{ getPaymentTypeName(s.cc_pay_type_cd) }}
                                    {{ s.cc_bill_price | numberFormatFilter }}원
                                </span>
                                <span v-else-if="s.cc_sale_type_cd === '-' && !s.cc_ret_yn" class="red">
                                    {{ getPaymentTypeName(s.cc_bill_pay_type_cd) }}
                                    {{ s.cc_exp_price | numberFormatFilter }}원
                                </span>
                                <span v-else-if="s.cc_ret_yn && s.cc_bill_seq === '0'" class="red">
                                    {{ getPaymentTypeName(s.cc_ret_pay_type_cd) }} -{{
                                        s.cc_ret_price | numberFormatFilter
                                    }}원
                                </span>
                                <span
                                    v-if="s.cc_total_debt_price != 0 && s.cc_prod_type_cd === 'T' && !s.cc_ret_yn"
                                    class="blue"
                                >
                                    미수금 {{ s.cc_total_debt_price | numberFormatFilter }}원
                                </span>
                                <!-- <span class="com-btn deep-black" v-if="s.cc_ret_type_cd">현</span>
                              <span class="com-btn deep-black" v-if="s.cc_ret_type_cd">세</span> -->
                            </span>
                        </td>
                        <td>
                            <span v-if="s.cc_sale_type_cd === '+' && s.cc_prod_type_cd === 'T' && !s.cc_ret_yn">
                                {{ convertType(s.cc_sale_staff_contract_type_cd) }}
                            </span>
                        </td>
                        <td>{{ s.cc_less_staff_name }}</td>
                        <td>{{ s.cc_sale_staff_name }}</td>
                        <td>{{ s.cc_center_nm }}</td>
                    </tr>

                    <tr v-if="saleGoodsList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <!-- 추후에 구현함 -->
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { pagingInfo, TICKET_TYPES } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'SalesGoods',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
            centerChains: 'auth/centerChains'
        }),
        rNm() {
            const { getters } = this.$store;
            if (getters['auth/roleName'] !== '대표관리자') {
                return true;
            }
            return false;
        },
        totalPrice() {
            return (
                parseInt(this.ticketTypeSale.total.price) +
                parseInt(this.etcProductPrice) -
                parseInt(this.statRefund.refund.price)
            );
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.dateChangeInit();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        searchBillTypes(newValue) {
            // 결제항목
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        searchTicketTypes(newValue) {
            // 이용권구분
            let findIndex;
            newValue.forEach((v, index) => {
                if (v === 'all') findIndex = index;
            });
            // newValue.splice(findIndex, 1);
            this.searchTicketTypes = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;

            this.refreshProductList();
        },
        saleStaff(newValue) {
            this.saleStaffId = newValue;
            this.dateChangeInit();
        },
        teacherStaff(newValue) {
            this.teacherStaff = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        selectedCenter(newValue) {
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        category(newValue) {
            this.category = newValue;
            this.dateChangeInit();
        },
        prod(newValue) {
            this.prod = newValue;
            this.dateChangeInit();
        },
        payType(newValue) {
            this.payType = newValue;
            this.dateChangeInit();
        },
        contractType(newValue) {
            this.contractType = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        searchCategoryNames(newValue) {
            let findIndex;
            newValue.forEach((v, index) => {
                if (v === 'all') findIndex = index;
            });
            // newValue.splice(findIndex, 1);
            this.searchCategoryNames = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        searchProductItem(newValue) {
            let findIndex;
            newValue.forEach((v, index) => {
                if (v === 'all') findIndex = index;
            });
            // newValue.splice(findIndex, 1);
            this.searchProductItem = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        searchTeacher(newValue) {
            let findIndex;
            newValue.forEach((v, index) => {
                if (v === 'all') findIndex = index;
            });
            // newValue.splice(findIndex, 1);
            this.searchTeacher = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
        searchStaff(newValue) {
            let findIndex;
            newValue.forEach((v, index) => {
                if (v === 'all') findIndex = index;
            });
            // newValue.splice(findIndex, 1);
            this.searchStaff = newValue;
            if (this.salesCount > 7) {
                this.dateChangeInit();
            }
            this.salesCount += 1;
        },
    },
    data() {
        return {
            sort: {
                cc_buy_dt: 'DESC',
                ticket: 'DESC',
                cc_ticket_type_cd: 'DESC',
                cc_total_buy_price: 'DESC',
                cc_bill_price: 'DESC',
                cc_less_staff_name: 'DESC',
                cc_sale_staff_name: 'DESC',
                cc_center_nm: 'DESC',
            },
            sortColumn: '',
            sortType: '',

            roleName: '', // 역할이름
            saleGoodsList: [],
            totalItems: '',
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: '', // 검색 기간 설정

            searchBillTypes: [], // 결제 항목(P, D, C)
            searchTicketTypes: [], // 이용권 구분 (P, O, D, G, C, T)
            searchCategoryNames: [], // 카테고리명
            searchProductItem: [], // 이용권 명
            searchTeacher: [], // 강사명
            searchStaff: [], // 매출직원

            payType: '', // 결제 수단 구분(C,L,B,M,E)
            contractType: '', // 계약 유형 코드
            staffNameList: [],
            staffNameValueList: [],
            teacherList: [], // 강사 직원
            teacherValueList: [],
            teacherStaff: '',
            saleStaff: '',

            chainCenterType: [],
            chainCenterTypeValue: [],
            selectedCenter: '',

            // 결제수단별 매출
            salePayType: {
                card: {
                    price: 0,
                    count: 0,
                },
                cash: {
                    price: 0,
                    count: 0,
                },
                bank: {
                    price: 0,
                    count: 0,
                },
                etc: {
                    price: 0,
                    count: 0,
                },
                fit: {
                    price: 0,
                    count: 0,
                },
                mileage: {
                    price: 0,
                    count: 0,
                },
                total: {
                    price: 0,
                    count: 0,
                },
            },
            // 이용권 구분별 매출
            ticketTypeSale: {
                total: {
                    count: 0,
                    price: 0,
                },
                p: {
                    count: 0,
                    price: 0,
                },
                o: {
                    count: 0,
                    price: 0,
                },
                d: {
                    count: 0,
                    price: 0,
                },
                g: {
                    count: 0,
                    price: 0,
                },
                c: {
                    count: 0,
                    price: 0,
                },
                t: {
                    count: 0,
                    price: 0,
                },
                s: {
                    count: 0,
                    price: 0,
                },
                pk: {
                    count: 0,
                    price: 0,
                },
            },
            // 이용권 등록 현황
            ticketStat: {
                new: {
                    count: 0,
                    price: 0,
                },
                re: {
                    count: 0,
                    price: 0,
                },
                total: {
                    count: 0,
                    price: 0,
                },
            },
            // 환불
            statRefund: {
                refund: {
                    count: 0,
                    price: 0,
                },
                uncol: {
                    count: 0,
                    price: 0,
                },
            },
            // 예상부가세
            estiVat: {
                sale: '',
                buy: '',
            },
            category: '',
            categoryList: [],
            categoryValList: [],
            prod: '',
            prodList: [],
            prodValList: [],

            changePayType: '',
            changeContractType: '',
            etcProductPrice: '',
            etcProductCount: '',
            saleVat: '',
            outStandYn: '', // 미수금여부

            dateChangeCount: 1,
            salesCount: 1,
            uncol: {},
        };
    },
    created() {
        this.TICKET_TYPES = TICKET_TYPES;
        this.productAll = [];
    },
    mounted() {
        this.goMainIfNotAllowed('SA', 1);

        this.selectedCenter = parseInt(this.centerId); // 선택된 센터id
        this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음
        this.pagingInfo.page = 1;
        this.pagingInfo.limit = 10;
        this.init();
    },
    methods: {
        async changeTyped(targetColumn, number) {
            this.sortColumn = targetColumn;
            if (number === 1) {
                const temp = this.sort.cc_buy_dt === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_buy_dt = temp;
            }
            if (number === 2) {
                const temp = this.sort.ticket === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.ticket = temp;
            }
            if (number === 3) {
                const temp = this.sort.cc_ticket_type_cd === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_ticket_type_cd = temp;
            }
            if (number === 4) {
                const temp = this.sort.cc_total_buy_price === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_total_buy_price = temp;
            }
            if (number === 5) {
                const temp = this.sort.cc_bill_price === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_bill_price = temp;
            }
            if (number === 6) {
                const temp = this.sort.cc_less_staff_name === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_less_staff_name = temp;
            }
            if (number === 7) {
                const temp = this.sort.cc_sale_staff_name === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_sale_staff_name = temp;
            }
            if (number === 8) {
                const temp = this.sort.cc_center_nm === 'DESC' ? 'ASC' : 'DESC';
                this.sortType = temp;
                this.sort.cc_center_nm = temp;
            }
            const { data } = await this.getSaleGoodsList();
            this.setPageParams(data);
            this.saleGoodsList = data.items;
            this.totalItems = data.meta.totalItems;
        },
        async getUncol() {
            const result = await this.getRefundUncol('T');
            this.uncol.price = result.data.totalDebtPrice == null ? 0 : result.data.totalDebtPrice;
            this.uncol.count = result.data.totalDebtCount == null ? 0 : result.data.totalDebtCount;
        },
        // 초기화
        init() {
            try {
                Promise.allSettled([
                    this.onSaleGoodsList(),
                    this.onFetchStaffList(), // 스태프 조회
                    this.onFetchTeachers(), // 강사 조회
                    this.fetchChainCenter(), // 센터 체인 조회
                    this.onCategoryList(),
                    this.onProductList(),
                    this.getUncol(),
                    this.onVatStat(),
                ]);
            } catch (error) {
                console.log(error);
                console.log('초기화에 실패하였습니다.');
            }
        },
        dateChangeInit() {
            try {
                this.outStandYn = '';
                Promise.allSettled([
                    this.onSaleGoodsList(), //
                    this.getUncol(), //
                    this.onVatStat(), //
                ]);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },

        // 리스트 조회
        async onSaleGoodsList() {
            try {
                const { data } = await this.getSaleGoodsList();
                this.setPageParams(data);
                this.saleGoodsList = data.items;
                this.totalItems = data.meta.totalItems;
                this.inputData(data.test[0], data.uncol, this.outStandYn === 'T');
                console.log('상품매출현황 조회', data);
            } catch (error) {
                console.log(error);
                console.log('상품현황 리스트 오류입니다.');
            }
        },
        inputData(data, uncol, misugum) {
            if (misugum) {
                this.statRefund.uncol.count = data.totaldebtcount;
                this.statRefund.uncol.price = data.totaldebt;
                return;
            }
            uncol.count = uncol.price ? uncol.count : 0;
            uncol.price = uncol.price ? uncol.price : 0;
            this.ticketTypeSale = {
                total: {
                    count: data.totaltickettypecount,
                    price: data.totaltickettype,
                },
                p: {
                    count: data.personalcount,
                    price: data.personal,
                },
                o: {
                    count: data.otcount,
                    price: data.ot,
                },
                d: {
                    count: data.duetcount,
                    price: data.duet,
                },
                g: {
                    count: data.groupcount,
                    price: data.group,
                },
                c: {
                    count: data.couponcount,
                    price: data.coupon,
                },
                t: {
                    count: data.membershipcount,
                    price: data.membership,
                },
                s: {
                    count: data.sportcount,
                    price: data.sport,
                },
                pk: {
                    count: data.totaltickettypecount,
                    price: data.totaltickettype,
                },
            };
            this.etcProductPrice = data.normal;
            this.etcProductCount = data.normalcount;
            // 결제수단별 매출
            this.salePayType = {
                card: {
                    price: data.totalcard,
                    count: data.totalcardcount,
                },
                cash: {
                    price: data.totalloan,
                    count: data.totalloancount,
                },
                bank: {
                    price: data.totalbank,
                    count: data.totalbankcount,
                },
                etc: {
                    price: data.totaletc,
                    count: data.totaletccount,
                },
                fit: {
                    price: data.totalfit,
                    count: data.totalfitcount,
                },
                mileage: {
                    price: data.totalmilege,
                    count: data.totalmilegecount,
                },
                total: {
                    price: data.totalpaytype,
                    count: data.totalpaytypecount,
                },
            };
            // 이용권 등록 현황
            (this.ticketStat = {
                new: {
                    count: data.new,
                    price: data.newprice,
                },
                re: {
                    count: data.renew,
                    price: data.renewprice,
                },
                total: {
                    count: parseInt(data.new) + parseInt(data.renew),
                    price: parseInt(data.newprice) + parseInt(data.renewprice),
                },
            }),
                // 환불
                (this.statRefund = {
                    refund: {
                        count: data.totalrefundcount,
                        price: data.totalrefund,
                    },
                    uncol: {
                        count: uncol.count,
                        price: uncol.price,
                    },
                });
            // 지출현황
            // this.usePayStat = {
            //     fix: {
            //         count: data.expstaticcount,
            //         price: data.expstatic,
            //     },
            //     vari: {
            //         count: data.expchangecount,
            //         price: data.expchange,
            //     },
            //     total: {
            //         count: data.totalexppricecount,
            //         price: data.totalexpprice,
            //     },
            // };
        },
        // 리스트 조회 api
        getSaleGoodsList() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/list`, {
                params: {
                    // centerId: this.centerId,
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'), // 검색시작일
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'), // 검색종료일
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType, // 결제타입
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    saleType: '+', // 매출 매입 유형 코드(상품인경우 + 전체인경우 없음)
                    outStandYn: this.outStandYn, // 미수금여부
                    ...this.pagingInfo,
                },
            });
        },
        // 매출직원 리스트 조회
        async onFetchStaffList() {
            try {
                const { data } = await this.getfetchStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('매출직원 리스트', data);
                data.forEach((g) => {
                    this.staffNameList.push(g.name);
                    this.staffNameValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 스태프 리스트 조회 API
        getfetchStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },
        // 등록구분 변환
        convertType(cd) {
            if (cd == 'N') {
                return '신규';
            } else if (cd == 'R') {
                return '재등록';
            }
        },
        // 상품 등록코드 변환
        convertProdType(cd, returnYn) {
            if (cd == 'T') {
                if (returnYn) {
                    return '환불';
                }
                return '이용권';
            } else if (cd === 'S' || cd === 'L' || cd === 'C') {
                return '판매';
            }
        },
        // 가격정보 변환
        convertBill(bill) {
            if (bill == null || bill == undefined) {
                return '';
            }
            const a = bill.split('|');
            const data = [];
            for (const e of a) {
                const b = e.split('_');
                data.push({
                    type: b[0],
                    amount: parseInt(b[1]),
                });
            }

            let sum = {};
            let type = '';
            for (const c of data) {
                if (sum.type == undefined) {
                    sum = c;
                } else {
                    sum.amount += c.amount;
                }
            }

            if (sum.type == 'C') {
                type = '카드';
            } else if (sum.type == 'L') {
                type = '현금';
            } else if (sum.type == 'B') {
                type = '계좌이체';
            } else if (sum.type == 'M') {
                type = '마일리지';
            } else if (sum.type == 'E') {
                type = '기타';
            }

            const result = `${type} ${sum.amount}원`;
            return result;
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSaleGoodsList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSaleGoodsList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.searchBillTypes = []; // 결제항목
            this.searchTicketTypes = []; // 이용권 구분 (P, O, D, G, C, T)
            this.payType = ''; // 결제타입
            this.contractType = '';
            this.saleStaffId = '';
            this.lessonStaffId = '';
            this.searchCategoryNames = []; // 센터상품카테고리템플릿아이디
            this.searchProductItem = []; // 이용권상품아이디
            this.searchTeacher = []; // 강사명
            this.searchStaff = []; // 매출직원
            this.searchType = '';
            EventBus.$emit('event:initList', 'init');
        },
        // 페이징 기본값
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            if (this.salesCount > 7) {
                this.onSaleGoodsList();
            }
            this.salesCount += 1;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            if (this.dateChangeCount > 2) {
                this.dateChangeInit();
            }
            this.dateChangeCount += 1;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            if (this.dateChangeCount > 2) {
                this.dateChangeInit();
            }
            this.dateChangeCount += 1;
        },
        // 이용권 구분 체크 변경시
        // onChangeTicketCode(val) {
        //     this.searchTicketTypes = val;
        // },
        // 결제수단별 매출현황 조회
        async payTypeSale() {
            try {
                const { data } = await this.getPayTypeSale();

                // 값 초기화
                this.salePayType.total.price = 0;
                this.salePayType.total.count = 0;

                /* 카드 */
                this.salePayType.card.price = data.cardSalePrice == null ? 0 : data.cardSalePrice;
                this.salePayType.card.count = data.cardSaleCount == null ? 0 : data.cardSaleCount;
                /* 계좌 */
                this.salePayType.bank.price = data.bankSalePrice == null ? 0 : data.bankSalePrice;
                this.salePayType.bank.count = data.bankSaleCount == null ? 0 : data.bankSaleCount;
                /* 현금 */
                this.salePayType.cash.price = data.cashSalePrice == null ? 0 : data.cashSalePrice;
                this.salePayType.cash.count = data.cashSaleCount == null ? 0 : data.cashSaleCount;
                /* 기타 */
                this.salePayType.etc.price = data.etcSalePrice == null ? 0 : data.etcSalePrice;
                this.salePayType.etc.count = data.etcSaleCount == null ? 0 : data.etcSaleCount;
                /* 핏페이 */
                this.salePayType.fit.price = data.fitSalePrice == null ? 0 : data.fitSalePrice;
                this.salePayType.fit.count = data.fitSaleCount == null ? 0 : data.fitSaleCount;
                /* 마일리지 */
                this.salePayType.mileage.price = data.mileageSalePrice == null ? 0 : data.mileageSalePrice;
                this.salePayType.mileage.count = data.mileageSaleCount == null ? 0 : data.mileageSaleCount;
                /* 합계 */
                this.salePayType.total.price =
                    data.saleTotalPriceNotMileage == null ? 0 : data.saleTotalPriceNotMileage;
                this.salePayType.total.count =
                    data.saleTotalCountNotMileage == null ? 0 : data.saleTotalCountNotMileage;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getPayTypeSale() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/paytype`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        // 이용권 구분별 매출
        // async ticketSale() {
        //     try {
        //         const { data } = await this.getTicketSale();
        //         console.log('이용권 구분별 매출', data);
        //
        //         this.ticketTypeSale.total.price = 0; // 초기화
        //         this.ticketTypeSale.total.count = 0; // 초기화
        //
        //         // 개인
        //         this.ticketTypeSale.p.price = data.personSalePrice == null ? 0 : data.personSalePrice;
        //         this.ticketTypeSale.p.count = data.personSaleCount == null ? 0 : data.personSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.personSalePrice == null ? 0 : data.personSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.personSaleCount == null ? 0 : data.personSaleCount);
        //         // 오티
        //         this.ticketTypeSale.o.price = data.OTSalePrice == null ? 0 : data.OTSalePrice;
        //         this.ticketTypeSale.o.count = data.OTSaleCount == null ? 0 : data.OTSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.OTSalePrice == null ? 0 : data.OTSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.OTSaleCount == null ? 0 : data.OTSaleCount);
        //         // 듀엣
        //         this.ticketTypeSale.d.price = data.duetSalePrice == null ? 0 : data.duetSalePrice;
        //         this.ticketTypeSale.d.count = data.duetSaleCount == null ? 0 : data.duetSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.duetSalePrice == null ? 0 : data.duetSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.duetSaleCount == null ? 0 : data.duetSaleCount);
        //         // 그룹
        //         this.ticketTypeSale.g.price = data.groupSalePrice == null ? 0 : data.groupSalePrice;
        //         this.ticketTypeSale.g.count = data.groupSaleCount == null ? 0 : data.groupSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.groupSalePrice == null ? 0 : data.groupSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.groupSaleCount == null ? 0 : data.groupSaleCount);
        //         // 쿠폰
        //         this.ticketTypeSale.c.price = data.couponSalePrice == null ? 0 : data.couponSalePrice;
        //         this.ticketTypeSale.c.count = data.couponSaleCount == null ? 0 : data.couponSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.couponSalePrice == null ? 0 : data.couponSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.couponSaleCount == null ? 0 : data.couponSaleCount);
        //         // 회원권
        //         this.ticketTypeSale.t.price = data.memberShipSalePrice == null ? 0 : data.memberShipSalePrice;
        //         this.ticketTypeSale.t.count = data.memberShipSaleCount == null ? 0 : data.memberShipSaleCount;
        //         this.ticketTypeSale.total.price += parseInt(data.memberShipSalePrice == null ? 0 : data.memberShipSalePrice);
        //         this.ticketTypeSale.total.count += parseInt(data.memberShipSaleCount == null ? 0 : data.memberShipSaleCount);
        //     } catch (error) {
        //         console.log(error);
        //         console.log('error');
        //     }
        // },
        getTicketSale() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/tickettype`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        // 이용권 등록현황
        async onTicketStat() {
            try {
                const { data } = await this.getTicketStat();

                // 값 초기화
                this.ticketStat.total.price = 0;
                this.ticketStat.total.count = 0;

                // 신규
                this.ticketStat.new.price = data.newSalePrice == null ? 0 : data.newSalePrice;
                this.ticketStat.new.count = data.newSaleCount == null ? 0 : data.newSaleCount;
                // 재등록
                this.ticketStat.re.price = data.renewSalePrice == null ? 0 : data.renewSalePrice;
                this.ticketStat.re.count = data.renewSaleCount == null ? 0 : data.renewSaleCount;
                // 총합
                this.ticketStat.total.price = data.totalPrice == null ? 0 : data.totalPrice;
                this.ticketStat.total.count = data.totalCount == null ? 0 : data.totalCount;

                // data.forEach((g)=>{
                //     if(g.cc_contract_type_cd == 'N'){
                //         this.ticketStat.new.price = g.cc_total_buy_price;
                //         this.ticketStat.new.count = g.cc_contract_type_cd_cnt;
                //     }else if(g.cc_contract_type_cd == 'R'){
                //         this.ticketStat.re.price = g.cc_total_buy_price;
                //         this.ticketStat.re.count = g.cc_contract_type_cd_cnt;
                //     }
                //     this.ticketStat.total.price += parseInt(g.cc_total_buy_price);
                //     this.ticketStat.total.count += parseInt(g.cc_contract_type_cd_cnt);
                //     })
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getTicketStat() {
            // 스웨거 검색: 신규/재등록 현황 조회
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/ticekt`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        // 환불현황
        async refundStat() {
            try {
                const { data } = await this.getRefundStat();
                console.log('환불 및 미수금', data);
                const result = await this.getRefundUncol();

                // 환불현황
                this.statRefund.refund.price = data.totalRefundPrice == null ? 0 : data.totalRefundPrice;
                this.statRefund.refund.count = data.totalRefundCount == null ? 0 : data.totalRefundCount;
                // 미수금
                this.statRefund.uncol.price = result.data.totalDebtPrice == null ? 0 : result.data.totalDebtPrice;
                this.statRefund.uncol.count = result.data.totalDebtCount == null ? 0 : result.data.totalDebtCount;

                // data.forEach((g)=>{
                //     if(g.cc_type == '환불'){
                //         this.statRefund.refund.price = g.cc_total_price
                //         this.statRefund.refund.count = g.cc_cnt
                //     }else if(g.cc_type == '미수금'){
                //         this.statRefund.uncol.price = g.cc_total_price
                //         this.statRefund.uncol.count = g.cc_cnt
                //     }
                // })
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getRefundStat() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/refund`, {
                params: {
                    searchStr: this.searchStr,
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                },
            });
        },
        getRefundUncol(outStandYn) {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/debt`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    outStandYn,
                    searchStr: this.searchStr,
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        // 카테고리명 조회
        async onCategoryList() {
            try {
                const { data } = await this.getCategoryList();
                console.log(data);
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('카테고리 값을 가져오는데 실패했습니다.');
            }
        },
        getCategoryList() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 이용권명 조회
        async onProductList() {
            try {
                const { data } = await this.getProductList();
                this.productAll = data.filter((prod) => prod.stockUseYn);

                this.refreshProductList();
            } catch (error) {
                console.log(error);
            }
        },
        getProductList() {
            return api.get(`/admin/api/center/${this.centerId}/product/ticket/all`);
        },

        refreshProductList() {
            this.prodList.splice(0);
            this.prodValList.splice(0);

            const types = Object.keys(TICKET_TYPES);
            this.productAll
                .filter((prod) => !this.searchTicketTypes.length || this.searchTicketTypes.includes(prod.ticketType))
                .sort((a, b) => {
                    const a_order = types.indexOf(a.ticketType);
                    const b_order = types.indexOf(b.ticketType);

                    if (a_order < b_order) return -1;
                    if (a_order > b_order) return 1;

                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;

                    return 0;
                })
                .forEach((g) => {
                    this.prodList.push(`[${this.TICKET_TYPES[g.ticketType]}] ${g.name}`);
                    this.prodValList.push(g.centerProductId);
                });
        },

        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const pagingInfoTemp = this.pagingInfo;
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 100000;

            const { data } = await this.getSaleGoodsListExcel(); // 엑셀용 요청값
            console.log(data);

            this.pagingInfo = pagingInfoTemp;

            const excelDownloadArray = [];
            data.items.forEach((s) => {
                const temp = {};
                temp['결제일'] = timestampToDate(s.cc_buy_dt);
                temp['회원명'] = s.cc_customer_nm;
                temp['연락처'] = s.cc_phone;
                temp['결제항목'] = this.convertBillType(
                    s.cc_sale_type_cd,
                    s.cc_prod_type_cd,
                    s.cc_ret_yn,
                    s.cc_exp_type_cd
                );
                temp['항목명'] = this.convertTicket(s.cc_ticket_type_cd) + s.cc_prod_nm;

                if (s.cc_exp_start_dt == null) {
                    temp['유효기간'] = '';
                } else {
                    temp['유효기간'] = `${moment(s.cc_exp_start_dt).format('YYYY-MM-DD')} ~ ${moment(
                        s.cc_exp_end_dt
                    ).format('YYYY-MM-DD')}`;
                }

                if (s.cc_sale_type_cd === '-') {
                    return;
                    // temp['구매가'] = '';
                    // temp['카드'] = s.cc_bill_pay_type_cd === 'C' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_exp_price)) : '';
                    // temp['현금'] = s.cc_bill_pay_type_cd === 'L' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_exp_price)) : '';
                    // temp['계좌이체'] = s.cc_bill_pay_type_cd === 'B' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_exp_price)) : '';
                    // temp['마일리지'] = s.cc_bill_pay_type_cd === 'M' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_exp_price)) : '';
                    // temp['기타'] = s.cc_bill_pay_type_cd === 'E' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_exp_price)) : '';
                }
                // temp['구매가'] = !s.cc_ret_yn ? numberFormat(s.cc_total_buy_price) : '';
                if (!s.cc_ret_yn && s.cc_bill_seq !== '0' && s.cc_prod_type_cd === 'T') {
                    temp['구매가'] = `${Number(s.cc_bill_seq) + 1}차 결제`;
                } else {
                    temp['구매가'] = !s.cc_ret_yn ? numberFormat(s.cc_total_buy_price) : '';
                }
                if (s.cc_ret_yn && s.cc_bill_seq === '0') {
                    // temp['카드'] = s.cc_pay_type_cd === 'C' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)) : '';
                    // temp['현금'] = s.cc_pay_type_cd === 'L' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)) : '';
                    // temp['계좌이체'] = s.cc_pay_type_cd === 'B' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)) : '';
                    // temp['마일리지'] = s.cc_pay_type_cd === 'M' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)) : '';
                    // temp['기타'] = s.cc_pay_type_cd === 'E' ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)) : '';
                    temp['카드'] = '';
                    temp['현금'] = '';
                    temp['계좌이체'] = '';
                    temp['마일리지'] = '';
                    temp['기타'] = '';
                    temp['환불'] = numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price));
                } else {
                    temp['카드'] =
                        s.cc_pay_type_cd === 'C'
                            ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price))
                            : '';
                    temp['현금'] =
                        s.cc_pay_type_cd === 'L'
                            ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price))
                            : '';
                    temp['계좌이체'] =
                        s.cc_pay_type_cd === 'B'
                            ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price))
                            : '';
                    temp['마일리지'] =
                        s.cc_pay_type_cd === 'M'
                            ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price))
                            : '';
                    temp['기타'] =
                        s.cc_pay_type_cd === 'E'
                            ? numberFormat(this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price))
                            : '';
                    temp['환불'] = '';
                }

                temp['미수금'] =
                    s.cc_total_debt_price != 0 && s.cc_prod_type_cd === 'T' && !s.cc_ret_yn && s.cc_bill_seq === '0'
                        ? numberFormat(s.cc_total_debt_price * -1)
                        : '';
                temp['부가세'] =
                    s.cc_pay_type_cd !== 'M'
                        ? numberFormat(
                              Math.floor(
                                  (this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price) * 10) / 11
                              )
                          )
                        : '';
                temp['마일리지 적립'] = numberFormat(s.cc_total_add_mileage);
                temp['카드명'] = this.convertCardType(s.cc_pay_card_type_cd);
                temp['영수증'] =
                    s.cc_recp_type_cd !== 'N'
                        ? `${s.cc_recp_type_cd ? this.convertReceiptType(s.cc_recp_type_cd) : ''} ${
                              s.cc_recp_no ? s.cc_recp_no : ''
                          }`
                        : '';
                temp['메모'] = s.cc_memo;
                temp['등록구분'] =
                    s.cc_sale_type_cd === '+' && s.cc_prod_type_cd === 'T' && !s.cc_ret_yn && s.cc_bill_seq === '0'
                        ? this.convertType(s.cc_sale_staff_contract_type_cd)
                        : '';
                temp['담당강사'] = s.cc_less_staff_name;
                temp['매출직원'] = s.cc_sale_staff_name;
                temp['센터명'] = s.cc_center_nm;

                excelDownloadArray.push(temp);
            });

            const sumReducer = (prevValue, currentValue) => prevValue + currentValue;

            // 합계 부분 산출
            const temp = {};
            temp['결제일'] = '';
            temp['회원명'] = '';
            temp['연락처'] = '';
            temp['결제항목'] = '';
            temp['항목명'] = '';
            temp['유효기간'] = '합계';

            let sumPrice = 0;
            let sumCard = 0;
            let sumCash = 0;
            let sumAccount = 0;
            let sumMileage = 0;
            let sumEtc = 0;
            let sumRefund = 0;

            let sumSalesPrice = 0;

            data.items.map((s) => {
                if (!s.cc_ret_yn) {
                    if (s.cc_bill_seq !== '0' && s.cc_prod_type_cd === 'T') {
                        sumPrice += 0;
                    } else {
                        sumPrice += s.cc_total_buy_price;
                    }
                } else {
                    sumPrice += 0;
                }

                if (s.cc_sale_type_cd === '-') {
                } else if (s.cc_pay_type_cd === 'C' && s.cc_ret_yn === false) {
                    sumCard += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price)
                            : 0;
                } else if (s.cc_pay_type_cd === 'L' && s.cc_ret_yn === false) {
                    sumCash += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price)
                            : 0;
                } else if (s.cc_pay_type_cd === 'B' && s.cc_ret_yn === false) {
                    sumAccount += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price)
                            : 0;
                } else if (s.cc_pay_type_cd === 'M' && s.cc_ret_yn === false) {
                    sumMileage += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price)
                            : 0;
                } else if (s.cc_pay_type_cd === 'E' && s.cc_ret_yn === false) {
                    sumEtc += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price)
                            : 0;
                } else if (s.cc_ret_yn === true) {
                    sumRefund += this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price);
                    sumSalesPrice +=
                        s.cc_prod_type_cd === 'T'
                            ? this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_ret_price)
                            : 0;
                }
            });

            const sumDebt = data.items
                .map((s) =>
                    s.cc_total_debt_price != 0 && s.cc_prod_type_cd === 'T' && !s.cc_ret_yn && s.cc_bill_seq === '0'
                        ? s.cc_total_debt_price * -1
                        : 0
                )
                .reduce(sumReducer);

            temp['구매가'] = numberFormat(sumPrice);
            temp['카드'] = numberFormat(sumCard);
            temp['현금'] = numberFormat(sumCash);
            temp['계좌이체'] = numberFormat(sumAccount);
            temp['마일리지'] = numberFormat(sumMileage);
            temp['기타'] = numberFormat(sumEtc);
            temp['환불'] = numberFormat(sumRefund);
            temp['미수금'] = numberFormat(sumDebt);
            temp['부가세'] = numberFormat(
                data.items
                    .map((s) =>
                        s.cc_pay_type_cd !== 'M'
                            ? Math.floor(
                                  (this.convertBillPrice(s.cc_ret_yn, s.cc_sale_type_cd, s.cc_bill_price) * 10) / 11
                              )
                            : 0
                    )
                    .reduce(sumReducer)
            );

            temp['마일리지 적립'] = numberFormat(data.items.map((s) => s.cc_total_add_mileage || 0).reduce(sumReducer));
            temp['카드명'] = '';
            temp['영수증'] = '';
            temp['메모'] = '';
            temp['등록구분'] = '';
            temp['담당강사'] = '';
            temp['매출직원'] = '';
            temp['센터명'] = '';

            excelDownloadArray.push(temp);

            // 합계 부분 산출
            const temp2 = {};
            temp2['결제일'] = '';
            temp2['회원명'] = '';
            temp2['연락처'] = '';
            temp2['결제항목'] = '';
            temp2['항목명'] = '';
            temp2['유효기간'] = `매출 합계 : ${numberFormat(sumCard + sumCash + sumAccount + sumEtc + sumRefund)}`;
            temp2['구매가'] = '';
            temp2['카드'] = '';
            temp2['현금'] = '';
            temp2['계좌이체'] = '';
            temp2['마일리지'] = '';
            temp2['기타'] = '';
            temp2['부가세'] = '';
            temp2['미수금'] = '';
            temp2['마일리지 적립'] = '';
            temp2['카드명'] = '';
            temp2['영수증'] = '';
            temp2['메모'] = '';
            temp2['등록구분'] = '';
            temp2['담당강사'] = '';
            temp2['매출직원'] = '';
            temp2['센터명'] = '';

            excelDownloadArray.push(temp2);
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 10 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '매출현황 상품');
            XLSX.writeFile(wb, '매출현황_상품.xlsx');
        },
        getSaleGoodsListExcel() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/list`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                case 'D':
                    return '[듀엣]';
                case 'O':
                    return '[OT]';
                case 'G':
                    return '[그룹]';
                case 'C':
                    return '[쿠폰]';
                case 'T':
                    return '[회원권]';
                case 'S':
                    return '[운동복]';
                case null:
                    return '';
            }
        },
        // 이용권 구분 체크 변경시
        onChangeTicketCode(val) {
            this.searchTicketTypes = val;
        },
        async getEtcProductSale() {
            const startDate = moment(this.startDate).format('YYYYMMDD');
            const endDate = moment(this.endDate).format('YYYYMMDD');

            const { data } = await api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/etcproduct`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });

            console.log('일반상품', data);

            this.etcProductPrice = data.etcTotalSalePrice == null ? 0 : data.etcTotalSalePrice;
            this.etcProductCount = data.etcTotalSaleCount == null ? 0 : data.etcTotalSaleCount;
        },
        getPaymentTypeName(type) {
            return Utils.getPaymentTypeName(type);
        },
        async findCenterVat() {
            const startDate = moment(this.startDate).format('YYYYMMDD');
            const endDate = moment(this.endDate).format('YYYYMMDD');

            const { data } = await api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/vat`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });

            data.forEach((item) => {
                if (item.cc_type === '매출') {
                    this.saleVat = data.cc_total_vat_price | 0;
                }
            });
        },
        // 예상부가세 현황 조회
        async onVatStat() {
            try {
                const { data } = await this.fetchVatStat();
                this.estiVat.buy = data.expectedExpenseVat == null ? 0 : data.expectedExpenseVat;
                this.estiVat.sale = data.expectedSaleVat == null ? 0 : data.expectedSaleVat;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        fetchVatStat() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/report/vat`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: this.outStandYn === 'T' ? '' : moment(this.startDate).format('YYYYMMDD'),
                    endDate: this.outStandYn === 'T' ? '' : moment(this.endDate).format('YYYYMMDD'),
                    billTypes: this.searchBillTypes.join(','),
                    ticketTypes: this.searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                    payType: this.payType,
                    saleStaffContractType: this.contractType,
                    centerProductCategoryTemplateIds: this.searchCategoryNames.join(','), // 센터상품카테고리템플릿아이디
                    centerProductIds: this.searchProductItem.join(','), // 이용권상품아이디
                    lessonStaffIds: this.searchTeacher.join(','), // 강사명
                    saleStaffIds: this.searchStaff.join(','), // 매출직원
                    outStandYn: this.outStandYn, // 미수금여부
                    // centerId: this.centerId,
                    ...this.pagingInfo,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                },
            });
        },
        // 상품 등록코드 변환
        convertBillType(saleType, productType, returnYn, expenseType) {
            if (productType === 'T' && !returnYn && saleType === '+') {
                return '이용권';
            } else if (productType === 'T' && returnYn && saleType === '+') {
                return '환불';
            } else if ((productType === 'L' || productType === 'C' || productType === 'S') && saleType === '+') {
                return '판매';
            } else if (expenseType === 'F' && saleType === '-') {
                return '지출-고정';
            } else if (expenseType === 'C' && saleType === '-') {
                return '지출-변동';
            }
        },
        uncollectedList() {
            alert('미수금 리스트');
            this.outStandYn = 'T';
            this.onSaleGoodsList();
        },
        convertCardType(payCardType) {
            switch (payCardType) {
                case 'KB':
                    return 'KB국민카드';
                case 'BC':
                    return '비씨';
                case 'SM':
                    return '삼성';
                case 'HY':
                    return '현대';
                case 'LO':
                    return '롯데';
                case 'SH':
                    return '신한';
                case 'HA':
                    return '하나';
                case 'NH':
                    return 'NH농협';
                case 'WR':
                    return '외환';
                case 'CT':
                    return '씨티';
                case 'SUH':
                    return '수협';
                case 'CU':
                    return '신협';
                case 'KDB':
                    return 'KDB';
                case 'KG':
                    return '광주';
                case 'JB':
                    return '전북';
                case 'JJ':
                    return '제주';
                case 'KA':
                    return '케이뱅크';
                case 'KAKAO':
                    return '카카오뱅크';
                case 'ET':
                    return '기타';
            }
        },
        convertReceiptType(receiptType) {
            switch (receiptType) {
                case 'T':
                    return '세금계산서';
                case 'C':
                    return '현금계산서';
            }
        },
        convertBillPrice(returnYn, saleType, billPrice) {
            if (returnYn || saleType === '-') {
                return -1 * billPrice;
            }
            return billPrice;
        },
    },
};
</script>
<style lang="scss"></style>
